app.config(function ($translateProvider) {
    $translateProvider.translations('zh-hk', {
        'en-gb': 'English',
        'fr': 'Francais',
        'es': 'Espanol',
        'nl': 'Nederlands',
        'zh-hk': '繁體中文'
    });
});
